const values = {
  WRITING_TASK_1: 'IELTS Writing Task 1 Sample',
  WRITING_TASK_2_ACADEMIC: 'IELTS Writing Academic Task 2 Sample',
  WRITING_TASK_2_GENERAL: 'IELTS Writing General Task 1 Sample',

  SPEAKING_PART_1: 'IELTS Speaking Part 1',
  SPEAKING_PART_2: 'IELTS Speaking Part 2',
  SPEAKING_PART_3: 'IELTS Speaking Part 3',

  OVERALL: 'Overall',
  TASK_ACHIEVEMENT: 'Task Achievement',
  GRAMMAR: 'Grammar',
  VOCABULARY: 'Vocabulary',
  COHERENCE_AND_COHESION: 'Overall',
};

export const getPageSampleTitleEnumTextByKey = (key) => {
  return values[key] || key;
};
